import { IPlanCategory } from 'app/shared/model/plan-category.model';

export interface IPlans {
  id?: number;
  planTitle?: string;
  planPrice?: number;
  planDescription?: string;
  planLogoContentType?: string;
  planLogo?: string;
  planSuitableFor?: string;
  planCategory?: IPlanCategory;
}

export const defaultValue: Readonly<IPlans> = {};
